import { type FormEvent, useState } from "react";
import { Link } from "react-router";
import { AuthLayout } from "../components/AuthLayout";
import { requestPasswordReset } from "../lib/auth";

const GENERIC_RECOVERY_MESSAGE =
  "Als dit e-mailadres bij een DBVDW-account hoort, ontvang je een e-mail met een link om je wachtwoord opnieuw in te stellen.";

function isRateLimited(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  return (error as Error & { status?: number }).status === 429;
}

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [rateLimited, setRateLimited] = useState(false);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setSubmitting(true);
    setRateLimited(false);
    try {
      await requestPasswordReset(email);
    } catch (error) {
      if (isRateLimited(error)) {
        setRateLimited(true);
      } else {
        console.error("Password reset request failed", error);
      }
    } finally {
      setSubmitted(true);
      setSubmitting(false);
    }
  }

  return (
    <AuthLayout>
      <h1>Wachtwoord vergeten</h1>
      {!submitted
        ? (
          <>
            <p>Vul het e-mailadres van je DBVDW-account in.</p>
            <form onSubmit={handleSubmit}>
              <label htmlFor="recovery-email">E-mailadres</label>
              <input
                id="recovery-email"
                name="email"
                type="email"
                autoComplete="email"
                required
                disabled={submitting}
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
              <button type="submit" disabled={submitting}>
                {submitting ? "Versturen..." : "Resetlink aanvragen"}
              </button>
            </form>
          </>
        )
        : (
          <>
            <p role="status">{GENERIC_RECOVERY_MESSAGE}</p>
            {rateLimited && (
              <p>
                Er zijn veel resetaanvragen verwerkt. Ontvang je geen e-mail, probeer het later
                opnieuw.
              </p>
            )}
          </>
        )}
      <p>
        <Link to="/login/">Terug naar inloggen</Link>
      </p>
    </AuthLayout>
  );
}
